import styled from "styled-components";


export const StyledTechUL = styled.ul`

    width: 100%;
    background-color: var(--color-grey-3);

    border-radius: 4px;

    margin-top: 50px;

    padding: 22px;

    display: flex;
    flex-direction: column;

    gap: 14px;

    @media (max-width:700px) {
        padding: 13px;
    }

`

export const EmptyListMsg = styled.h2`

    color: var(--color-grey-0);
    margin-top: 60px;
    font-size: 1rem;
    font-weight: 600;
`